import { css } from '@emotion/react';

export const dialogFormBlock = css`
  div& {
    padding: 0;
  }
`;
